export default "__VITE_ASSET__wPii1oS$__"